export const RECEIVE_ALBUM = 'iHR/Album/RECEIVE_ALBUM';
export const RECEIVE_ALBUMS = 'iHR/Album/RECEIVE_ALBUMS';
export const RECEIVE_ADDITIONAL_ALBUMS = 'iHR/Album/RECEIVE_ADDITIONAL_ALBUMS';
